const API_URL = process.env.NEXT_PUBLIC_API_URL || ''

const BASE = API_URL + '/api/news'

export interface NewsItem {
  id: string
  slug: string
  title: string
  summary: string
  category: string
  tags: string[]
  relatedSymbols: string[]
  source: string
  publishedAt: string
  updatedAt?: string
  isFeatured: boolean
  imageUrl?: string
  views: number
  likes: number
  dislikes: number
  commentCount: number
}

export interface NewsDetail extends NewsItem {
  content: string
}

export interface NewsListResponse {
  data: NewsItem[]
  totalCount: number
  page: number
  pageSize: number
  totalPages: number
}

export async function fetchBreakingNews(lang = 'tr'): Promise<NewsItem[]> {
  try {
    // Haber listesi sayfası E7 için dinamik render'a geçti; veri katmanı önbelleğe
    // alınmasa her istek backend'e giderdi. 60 sn son dakika şeridi için yeterince taze.
    const res = await fetch(`${BASE}/breaking?lang=${lang}`, {
      next: { revalidate: 60 },
    })
    if (!res.ok) return []
    const json: NewsListResponse = await res.json()
    return json.data ?? []
  } catch {
    return []
  }
}

export async function fetchNewsBySlug(slug: string, lang = 'tr'): Promise<NewsDetail | null> {
  try {
    const res = await fetch(`${BASE}/slug/${slug}?lang=${lang}`)
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}

export async function fetchNewsById(id: string, lang = 'tr'): Promise<NewsDetail | null> {
  try {
    const res = await fetch(`${BASE}/${id}?lang=${lang}`)
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}

export async function fetchNewsByCategory(category: string, page = 1, lang = 'tr'): Promise<NewsListResponse | null> {
  try {
    const res = await fetch(`${BASE}?category=${category}&page=${page}&pageSize=20&lang=${lang}`)
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}

export async function fetchAllNews(page = 1, pageSize = 12, category?: string, lang = 'tr', search?: string): Promise<NewsListResponse | null> {
  try {
    let url = `${BASE}?page=${page}&pageSize=${pageSize}&lang=${lang}`
    if (category) url += `&category=${category}`
    if (search) url += `&search=${encodeURIComponent(search)}`
    const res = await fetch(url)
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}

export async function viewNews(id: string): Promise<{ views: number } | null> {
  try {
    const res = await fetch(`${BASE}/${id}/view`, { method: 'POST' })
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}

export async function reactNews(id: string, type: 'like' | 'dislike' | 'none', previous: 'like' | 'dislike' | 'none'): Promise<{ likes: number; dislikes: number } | null> {
  try {
    const res = await fetch(`${BASE}/${id}/react?type=${type}&previous=${previous}`, { method: 'POST' })
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}
